import { Button, Checkbox, Icon, Input, Select } from 'semantic-ui-react';
import { FormSection, ToggleField } from './FormSection';
import { EmptyState, QuestionList, QuestionRow, ToggleList } from '../serviceFormStyles';
import { newExtraQuestion, QUESTION_TYPES } from '../serviceFormUtils';
import { searchSelectProps } from 'src/components/helpers';

const ExtraQuestionsSection = ({ inputs, updateInputs, errorInputs }) => {
  const questions = inputs.extraQuestions || [];

  const setQuestions = (nextQuestions) => updateInputs({ extraQuestions: nextQuestions });

  const updateQuestion = (id, changes) =>
    setQuestions(questions.map((q) => (q.id === id ? { ...q, ...changes } : q)));

  const removeQuestion = (id) => setQuestions(questions.filter((q) => q.id !== id));

  const addQuestion = () => setQuestions([...questions, newExtraQuestion()]);

  const toggleExtraInfo = () =>
    updateInputs({
      extraInfo: !inputs.extraInfo,
      ...(!inputs.extraInfo && questions.length === 0
        ? { extraQuestions: [newExtraQuestion()] }
        : {}),
    });

  return (
    <FormSection
      id="preguntas-extra"
      number={4}
      title="Preguntas extra"
      description="Pide información adicional al asistente durante la inscripción."
    >
      <ToggleList>
        <ToggleField
          name="extraInfo"
          label="Pedir información extra"
          checked={inputs.extraInfo}
          onChange={toggleExtraInfo}
        >
          {questions.length === 0 ? (
            <EmptyState>Aún no hay preguntas. Agrega la primera.</EmptyState>
          ) : (
            <QuestionList>
              {questions.map((question, index) => (
                <QuestionRow key={question.id}>
                  <span className="question__index">{index + 1}</span>
                  <Input
                    className="question__label"
                    aria-label={`Pregunta ${index + 1}`}
                    placeholder="Escribe la pregunta"
                    value={question.label}
                    onChange={(e) => updateQuestion(question.id, { label: e.target.value })}
                    error={Boolean(errorInputs[question.id])}
                  />
                  <Select
                    className="question__type"
                    aria-label="Tipo de respuesta"
                    {...searchSelectProps({
                      value: question.type,
                      handler: (e, { value }) => updateQuestion(question.id, { type: value }),
                      options: QUESTION_TYPES,
                    })}
                  />
                  <Checkbox
                    className="question__required"
                    toggle
                    label="Obligatoria"
                    checked={question.mandatory}
                    onChange={() => updateQuestion(question.id, { mandatory: !question.mandatory })}
                  />
                  <Button
                    type="button"
                    className="question__remove"
                    icon
                    basic
                    size="small"
                    aria-label={`Eliminar pregunta ${index + 1}`}
                    title="Eliminar pregunta"
                    onClick={() => removeQuestion(question.id)}
                  >
                    <Icon name="trash alternate outline" />
                  </Button>
                  {errorInputs[question.id] && (
                    <p className="question__error">Escribe la pregunta o elimínala.</p>
                  )}
                </QuestionRow>
              ))}
            </QuestionList>
          )}
          <Button type="button" basic color="blue" onClick={addQuestion}>
            <Icon name="plus" />
            Agregar pregunta
          </Button>
        </ToggleField>
      </ToggleList>
    </FormSection>
  );
};

export default ExtraQuestionsSection;
